import { defineMeta } from '@/registry/types';

export const speedDialMeta = defineMeta({
  name: 'SpeedDial',
  level: 'organism',
  category: 'input',
  classification: 'themed-mui',
  description: 'Floating button revealing a cluster of related actions. Themed MUI SpeedDial.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'SpeedDial',
  muiDocs: 'https://mui.com/material-ui/react-speed-dial/',
  a2uiEquivalent: 'SpeedDial',
  importPath: '@/organisms/SpeedDial',
  requiredProps: ['ariaLabel'],
  optionalProps: ['direction', 'icon', 'open', 'onOpen', 'onClose'],
  supportedStates: ['closed', 'open'],
  designTokens: ['colors', 'shadows'],
  accessibility: ['ariaLabel required; each action exposes a tooltip title.'],
  usageExamples: ['<SpeedDial ariaLabel="actions" icon={<SpeedDialIcon />}>...</SpeedDial>'],
  antiPatterns: ['Do not use for primary navigation.'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Compact action clusters on dense screens'],
  whenNotToUse: ['Single action (use FAB)'],
});

export default speedDialMeta;
